export const FLOWER_CATEGORY = 'flower'
export const CONCENTRATES_CATEGORY = 'concentrates'
export const EDIBLES_CATEGORY = 'edibles'
export const PREROLLS_CATEGORY = 'prerolls'
export const OTHER_CATEGORY = 'other'
